import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GeneralDataContextProvider } from './context/general-data-context';
import { PlannerContextProvider } from './context/planner-context';
import { NotificationContextProvider } from './context/notification-context';
import { UserContextProvider } from './context/user-context';
import { CacheApiContextProvider } from './context/cache-api-context';
import { PostHogProvider} from 'posthog-js/react';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  person_profiles: "identified_only",
  autocapture: false,
  disable_session_recording: true
}

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ErrorBoundary>
      <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={options as any}>
        <NotificationContextProvider>
          <UserContextProvider>
            <CacheApiContextProvider>
              <GeneralDataContextProvider>
                  <PlannerContextProvider>
                    <App />
                  </PlannerContextProvider>
              </GeneralDataContextProvider>
            </CacheApiContextProvider>
          </UserContextProvider>
        </NotificationContextProvider>
      </PostHogProvider>
    </ErrorBoundary>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
